import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import nameValidator from 'foundation/js/inputValidators/nameValidator'

const options = formFieldCommonOptions('FormInputNameField', {
    validatorFunction(input) {
        return nameValidator(input)
    }
})

export default options
